module.exports = __webpack_public_path__ + "components/flag/static/square/mm-46545f205421594cd8940f80917ad786.svg";